// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ay-4";
export var closeButton = "_ay-6";
export var dismissButton = "_ay-3";
export var editImageWithAiContainer = "_ay-8";
export var imageUploadWrapper = "_ay-7";
export var misspelledWord = "_ay-5";
export var spellCheckContainer = "_ay-2";
export var spin = "_ay-1";
export var spinning = "_ay-0";